module.exports = __webpack_public_path__ + "img/homeimage.3fb53bad.jpg";